import { initLazyLoad } from "@opportunus-lib-js/lazy-load/lazy-load";

$(document).ready(function() {
    initLazyLoad('snippet-favouriteProductsLazyLoading-showProductsSnippet', 'load-products-button', 'products-lazyloading-placeholder');
});